import React, {useState} from 'react';
import {Button, Row, Col, Modal, Card} from 'reactstrap';
import {useForm} from 'react-hook-form';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import {SweetAlert} from '../Common/SweetAlert';
import {Link} from 'react-router-dom';
import axios from 'axios';
import Dropzone from 'react-dropzone';

const ModalClaimAddFile = ({claim}) => {
  const [modal, setModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [noFileSelected, setNoFileSelected] = useState(false);
  const [successMsg, setSuccessMsg] = useState(false);
  const [errorMsg, setErrorMsg] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const {handleSubmit} = useForm();

  const toggleModal = () => {
    setModal(!modal);
    document.body.classList.add('no_padding');
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  };

  const handleAcceptedFiles = (files) => {
    files.map((file) =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      }),
    );
    setSelectedFiles(files);
  };

  const uploadFile = () => {
    const url = `${process.env.REACT_APP_APIURL}claim/${claim.id}/upload`;
    const authToken = authHeader();

    const formData = new FormData();
    selectedFiles.forEach((file) => formData.append('files[]', file));

    setIsLoading(true);
    axios
        .post(url, formData, {headers: authToken})
        .then(() => {
          setIsLoading(false);
          setSuccessMsg(true);
        })
        .catch(() => {
          setIsLoading(false);
          setErrorMsg(true);
        });
  };

  const onSubmit = () => {
    if (!selectedFiles.length) {
      setNoFileSelected(true);
      return false;
    }
    uploadFile();
  };

  return (
    <>
      <button
        className="position-absolute top-15 right-15 p-0 waves-effect waves-light btn btn-transparent text-yellow"
        type="button"
        onClick={toggleModal}
      >
        <i className="font-size-24 bx bxs-cloud-upload"></i>
      </button>

      <Modal size="lg" isOpen={modal} toggle={toggleModal} centered>
        <div className="modal-body">
          <button type="button" className="close" onClick={() => setModal(false)}>
            <span aria-hidden="true">&times;</span>
          </button>

          <Row>
            <Col md={1}>
              <div className="avatar-sm">
                <span className="avatar-title rounded-circle bg-primary text-white">
                  <i className="bx bxs-cloud-upload bx-sm"></i>
                </span>
              </div>
            </Col>

            <Col md={11}>
              <h5 className="modal-title mt-0">
                Upload files for claim {claim.fault_report_no}
              </h5>

              <form onSubmit={handleSubmit(onSubmit)}>
                <Dropzone
                  onDrop={handleAcceptedFiles}
                  accept=".jpg,.png,.pdf,.mp4,.log"
                  multiple
                >
                  {({getRootProps, getInputProps}) => (
                    <div className="dropzone">
                      <div className="dz-message needsclick" {...getRootProps()}>
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted bx bxs-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>

                <div className="dropzone-previews mt-3">
                  {selectedFiles.map((f, i) => (
                    <Card className="mt-1 mb-0 shadow-none border" key={i}>
                      <div className="p-2">
                        <Row className="align-items-center">
                          <Col>
                            <Link to="#" className="text-muted font-weight-bold">{f.name}</Link>
                            <p className="mb-0"><strong>{f.formattedSize}</strong></p>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  ))}
                </div>

                <div className="text-sm-right mt-2">
                  <Button color="yellow" type="submit" disabled={isLoading}>
                    {isLoading && <i className="bx bx-loader bx-spin mr-2" />}
                    Upload files
                  </Button>
                </div>
              </form>
            </Col>
          </Row>
        </div>
      </Modal>

      {successMsg && (
        <SweetAlert
          title="Good job!"
          success
          onConfirm={() => window.location.reload()}
        >
          File was uploaded successfully.
        </SweetAlert>
      )}

      {errorMsg && (
        <SweetAlert
          title="Request could not be submitted!"
          warning
          onConfirm={() => setErrorMsg(false)}
        >
          There was an error while submitting your request. Please try again or get in contact with our team.
        </SweetAlert>
      )}

      {noFileSelected ? <SweetAlert
        title="No file selected!"
        text="Please select a file to upload."
        warning
        showConfirm={true}
        showCancel={false}
        confirmBtnBsStyle="yellow"
        onConfirm={() => {
          setNoFileSelected(false);
        }}
      /> : null}
    </>
  );
};

export default ModalClaimAddFile;
